export default "assets/images/quote-default-70f91c67.png";